import { Renderer2, Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

// @Injectable()
export class ScriptService {
  // constructor(@Inject(DOCUMENT) private document: Document) {}

  public static loadJsScript(renderer: Renderer2, src: string, isAsync = true): HTMLScriptElement {
    const script = renderer.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    script.async = isAsync;
    renderer.appendChild(document.body, script);
    return script;
  }

  public static isScriptExist(src: string): boolean {
    const scripts = document.getElementsByTagName('script');
    for (let i = 0; i < scripts.length; i++) {
      if (scripts[i].getAttribute('src') === src) {
        return true;
      }
    }
    return false;
  }

  public static removeScript(src: string): void {
    const scripts = document.getElementsByTagName('script');
    for (let i = 0; i < scripts.length; i++) {
      if (scripts[i].getAttribute('src') === src) {
        scripts[i].remove();
      }
    }
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/services/script.service.ts